import { useId, useState } from "react";
import { Button, Field, Modal } from "../../components";
import styles from "./Esn.module.css";

export type RefusInscriptionModalProps = {
  open: boolean;
  pending: boolean;
  /** Le refus du serveur sur la dernière tentative, déjà mis en mots. */
  erreur: string | null;
  onConfirm: (motif: string) => void;
  onCancel: () => void;
};

/**
 * Le motif d'un refus d'inscription. Obligatoire, et interne : le contact
 * reçoit un courriel neutre qui ne le porte pas. Le champ garde ce qu'on a
 * tapé si le serveur refuse.
 */
export function RefusInscriptionModal({ open, pending, erreur, onConfirm, onCancel }: RefusInscriptionModalProps) {
  const [motif, setMotif] = useState("");
  const [touche, setTouche] = useState(false);
  const idAide = useId();
  const vide = motif.trim() === "";

  function confirmer() {
    setTouche(true);
    if (vide) {
      return;
    }
    onConfirm(motif.trim());
  }

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Refuser cette demande"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={pending}>
            Annuler
          </Button>
          <Button variant="danger" onClick={confirmer} loading={pending}>
            Refuser la demande
          </Button>
        </>
      }
    >
      <p id={idAide} className={styles.mention}>
        Le motif reste interne à l'ESN, conservé avec la demande. Le contact reçoit un courriel neutre,
        sans le motif. L'entreprise pourra redéposer une demande.
      </p>
      <Field label="Motif" required error={touche && vide ? "Indiquez pourquoi la demande est refusée." : (erreur ?? undefined)}>
        {(commande) => (
          <textarea
            {...commande}
            value={motif}
            maxLength={1000}
            rows={4}
            aria-describedby={idAide}
            onChange={(e) => setMotif(e.target.value)}
            disabled={pending}
          />
        )}
      </Field>
    </Modal>
  );
}
